import React from "react";
import {Link} from "react-router-dom";
import {Collections, Objects} from "components/index";
import Framework from "@beardeddevops/react.framework";
const {UniversalModal} = Framework.Elements;

// noinspection JSUnresolvedVariable
/**
 * @param {Transactions_Entries_Properties} entry
 * @param {Products_Properties} product
 * @param {function} onDelete
 * @param {function} onUpdate
 * @param {function} onModelOpen
 * @param {bool} modelUpdate
 * @param {array} locations
 * @param {object} history
 */
export default ({entry, product, onDelete, onUpdate, modelUpdate, onModelOpen, locations, history}) => (
	<div key={product.pkey} className="portlet box blue-hoki">
		<div className="portlet-title">
			<div className="caption">
				<i className="fa fa-barcode" />&nbsp;&nbsp;
				<Link to={"/products/" + product.pkey} style={{color: 'white'}}>{product.serial_number}</Link>
			</div>
			<div className="tools">
				<a href='#' onClick={() => onDelete(entry.pkey || null, product.pkey)} className="remove"
					style={{color: 'white'}}><i className={"fa fa-remove"} /></a>
			</div>
		</div>
		<div className="portlet-body">
			{/*<Link to={"/products/" + product.pkey} className="btn btn-sm blue-hoki pull-right">View</Link>*/}
			<a onClick={onModelOpen} className="btn btn-sm blue-hoki pull-right">View</a>
			<h5 style={{marginTop: 0}}>{product.type}</h5>
			<h5 style={{margin: 0}}>{product.manufacturers ? product.manufacturers.name : product.manufacturer_other} | {product.model} | {product.calibers ? product.calibers.name : product.caliber_other}</h5>
		</div>

		<UniversalModal
			locations={locations}
			history={history}
			name={"Product"}
			id={product.pkey}
			object={Objects.ProductUpdate}
			objectProps={{
				object: product
			}}
			toggle={modelUpdate}
			afterSave={onUpdate}
			size={"xl"}
		/>

	</div>
);
